import { useNavigate } from 'react-router'

import { Icons } from '@/theme/Images'
import { routes } from '@/data'
import MobileNavbar from './mobile-nav-menu'
import './navbar.css'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { ChevronDown, ChevronUp } from 'lucide-react'
import ProfileDropdownMenu from './profile-dropdown-menu'
import { useState } from 'react'

const NavBar = () => {
  const navigate = useNavigate()
  const pathname = location.pathname
  const search = location.search
  const pathWithSearch = `${pathname}${search}`
  const [selectedNavItem, setSelectedNavItem] = useState('')
  const toggleNavItem = itemName => {
    setSelectedNavItem(prevItem => (prevItem === itemName ? '' : itemName))
  }
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className={`w-dvw sticky top-0 z-20 px-[5%] lg:px-[10%] flex flex-row justify-between items-start ${isOpen ? 'max-md:h-dvh' : 'min-h-[72px]'}`}
      style={{
        background: 'linear-gradient(121.16deg, #2F3136 2.43%, #0C0C0E 95.4%)',
      }}
    >
      <div className="min-h-[72px] flex flex-row justify-start items-center">
        <MobileNavbar isOpen={isOpen} setIsOpen={setIsOpen} />
        <img
          src={Icons.fastenTextLogoWhite}
          alt="fasten text logo"
          className="w-[8rem] h-auto cursor-pointer"
          onClick={() => navigate('home')}
        />
        <ul className="hidden md:flex flex-row items-center justify-start h-full px-6 gap-2 max-lg:gap-0">
          {routes.map(item => {
            const haveSubRoutes = item?.routes && item?.routes?.length > 0
            const isOpen = selectedNavItem === item?.name
            const triggerButton = (
              <button
                id={`${item?.name.toLowerCase()}-button`}
                className={`select-none font-inter text-neutral-25 text-md font-semibold px-3 py-2 flex gap-1 max-lg:gap-0 items-center ${
                  pathname?.includes(item?.path) ? 'bg-brand-500 rounded-full text-white' : ''
                } cursor-pointer`}
                onClick={() => navigate(item?.path)}
              >
                {item?.name}
                {haveSubRoutes &&
                  (isOpen ? <ChevronUp size={16} color="white" /> : <ChevronDown size={16} color="white" />)}
              </button>
            )
            return (
              <li key={item?.name}>
                {item?.routes?.length > 0 ? (
                  <DropdownMenu modal={true} open={isOpen} onOpenChange={() => toggleNavItem(item?.name)}>
                    <DropdownMenuTrigger asChild onClick={() => toggleNavItem(item?.name)}>
                      {triggerButton}
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="hidden bg-white text-black border-neutral-400 border-1 rounded-lg md:flex flex-col gap-1 p-2">
                      {item?.routes?.map(subItem => (
                        <DropdownMenuItem
                          key={subItem?.name}
                          className={`cursor-pointer rounded-lg p-0 ${pathWithSearch?.includes(subItem?.path) ? 'bg-neutral-25' : ''}`}
                          onClick={() => navigate(subItem?.path)}
                        >
                          <button
                            id="account-button"
                            aria-label="Account"
                            className="flex flex-row justify-start items-center px-4 py-2 w-full"
                          >
                            <span className="text-neutral-900 font-medium text-sm">{subItem?.name}</span>
                          </button>
                        </DropdownMenuItem>
                      ))}
                    </DropdownMenuContent>
                  </DropdownMenu>
                ) : (
                  triggerButton
                )}
              </li>
            )
          })}
        </ul>
      </div>
      <div className="min-h-[72px] flex flex-row items-center">
        <ProfileDropdownMenu />
      </div>
    </div>
  )
}

NavBar.propTypes = {}

export default NavBar
